import a from "./index.es242.js";
import { FORMAT_ID_STARTS_FROM as R } from "./index.es244.js";
function y(n, r) {
  var e = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (e) return (e = e.call(n)).next.bind(e);
  if (Array.isArray(n) || (e = _(n)) || r) {
    e && (n = e);
    var i = 0;
    return function() {
      return i >= n.length ? { done: !0 } : { done: !1, value: n[i++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _(n, r) {
  if (n) {
    if (typeof n == "string") return H(n, r);
    var e = {}.toString.call(n).slice(8, -1);
    return e === "Object" && n.constructor && (e = n.constructor.name), e === "Map" || e === "Set" ? Array.from(n) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? H(n, r) : void 0;
  }
}
function H(n, r) {
  (r == null || r > n.length) && (r = n.length);
  for (var e = 0, i = Array(r); e < r; e++) i[e] = n[e];
  return i;
}
function on(n) {
  var r = n.formats, e = n.styles, i = n.fonts, C = n.fills, x = n.borders, t = '<?xml version="1.0" ?>';
  if (t += '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">', r.length > 0) {
    t += '<numFmts count="'.concat(r.length, '">');
    for (var c = 0; c < r.length; c++)
      t += '<numFmt numFmtId="'.concat(R + c, '" formatCode="').concat(a(r[c]), '"/>');
    t += "</numFmts>";
  }
  t += '<fonts count="'.concat(i.length, '">');
  for (var N = y(i), I; !(I = N()).done; ) {
    var l = I.value, X = l.size, $ = l.family, z = l.color, q = l.weight, G = l.style, J = l.custom;
    t += "<font>", t += '<sz val="'.concat(X, '"/>'), t += "<color ".concat(z ? 'rgb="' + a(w(z)) + '"' : 'theme="1"', "/>"), t += '<name val="'.concat(a($), '"/>'), t += '<family val="2"/>', J || (t += '<scheme val="minor"/>'), q === "bold" && (t += "<b/>"), G === "italic" && (t += "<i/>"), t += "</font>";
  }
  t += "</fonts>", t += '<fills count="'.concat(C.length, '">');
  for (var K = y(C), O; !(O = K()).done; ) {
    var j = O.value, E = j.color, P = j.gray125;
    t += "<fill>", E ? (t += '<patternFill patternType="solid">', t += '<fgColor rgb="'.concat(a(w(E)), '"/>'), t += '<bgColor indexed="64"/>', t += "</patternFill>") : P ? t += '<patternFill patternType="gray125"/>' : t += '<patternFill patternType="none"/>', t += "</fill>";
  }
  t += "</fills>", t += '<borders count="'.concat(x.length, '">');
  for (var Q = y(x), M; !(M = Q()).done; ) {
    var u = M.value, V = u.left, W = u.right, Y = u.top, Z = u.bottom, f = function(L, k) {
      var v = k.style, h = k.color;
      h && !v && (v = "thin");
      var D = !!h;
      return "<".concat(L) + (v ? ' style="'.concat(a(v), '"') : "") + (D ? ">" : "/>") + (h ? '<color rgb="'.concat(a(w(h)), '"/>') : "") + (D ? "</".concat(L, ">") : "");
    };
    t += "<border>", t += f("left", V), t += f("right", W), t += f("top", Y), t += f("bottom", Z), t += "<diagonal/>", t += "</border>";
  }
  t += "</borders>", t += '<cellXfs count="'.concat(e.length, '">');
  for (var B = y(e), S; !(S = B()).done; ) {
    var o = S.value, g = o.fontId, b = o.fillId, F = o.borderId, s = o.align, d = o.alignVertical, m = o.textRotation, p = o.indent, A = o.wrap, T = o.formatId;
    t += "<xf " + [
      T !== void 0 ? 'numFmtId="'.concat(T, '"') : void 0,
      T !== void 0 ? 'applyNumberFormat="1"' : void 0,
      g !== void 0 ? 'fontId="'.concat(g, '"') : void 0,
      g !== void 0 ? 'applyFont="1"' : void 0,
      b !== void 0 ? 'fillId="'.concat(b, '"') : void 0,
      b !== void 0 ? 'applyFill="1"' : void 0,
      F !== void 0 ? 'borderId="'.concat(F, '"') : void 0,
      F !== void 0 ? 'applyBorder="1"' : void 0,
      s || d || m || p || A ? 'applyAlignment="1"' : void 0
      // 'xfId="0"'
    ].filter(function(U) {
      return U;
    }).join(" ") + ">" + // Possible horizontal alignment values:
    //  left, center, right, fill, justify, center_across, distributed.
    // Possible vertical alignment values:
    //  top, vcenter, bottom, vjustify, vdistributed.
    // https://xlsxwriter.readthedocs.io/format.html#set_align
    (s || d || m || p || A ? "<alignment" + (s ? ' horizontal="'.concat(a(s), '"') : "") + (d ? ' vertical="'.concat(a(d), '"') : "") + (m ? ' textRotation="'.concat(tn(nn(m)), '"') : "") + (p ? ' indent="'.concat(a(String(p)), '"') : "") + (A ? ' wrapText="1"' : "") + "/>" : "") + "</xf>";
  }
  return t += "</cellXfs>", t += "</styleSheet>", t;
}
function w(n) {
  if (n[0] !== "#")
    throw new Error('Color "'.concat(n, '" must start with a "#"'));
  return "FF".concat(n.slice(1).toUpperCase());
}
function nn(n) {
  if (!(n >= -90 && n <= 90))
    throw new Error("Unsupported text rotation angle: ".concat(n, ". Values from -90 to 90 are supported."));
  return n;
}
function tn(n) {
  return n < 0 ? 90 - n : n;
}
export {
  on as default
};
//# sourceMappingURL=index.es217.js.map
